module.exports = __webpack_public_path__ + "media/images/athletes/3531-9212ed3004970be486b7075979a01cc1.png";